import { Component, OnInit, ChangeDetectorRef, AfterContentChecked, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FirebaseService } from 'src/app/commons/firebase.service';
import { FunctionsService } from 'src/app/data/functions.service';
import { PessoaValidador } from 'src/app/validators/pessoa-validador';
import { ConfirmationResult } from "firebase/auth";
import { UtilitariosDataService } from 'src/app/data/utilitarios-data.service';
import { SegurancaValidador } from 'src/app/validators/seguranca-validador';
import { StaticDataService } from 'src/app/data/static-data.service';

import firebase from 'firebase/compat/app';
import { AngularFireAuth } from '@angular/fire/compat/auth';

interface UploadEvent {
  // originalEvent: Event;
  files: File[];
}

@Component({
  selector: 'app-editar-dados-cliente',
  templateUrl: './editar-dados-cliente.component.html',
  styleUrls: ['./editar-dados-cliente.component.css']
})
export class EditarDadosClienteComponent implements OnInit {
  @Input() subtitulo: string;

  public clienteFormGroup: UntypedFormGroup;
  public enderecoFormGroup: UntypedFormGroup;
  public dadosBancariosFormGroup: UntypedFormGroup;
  public updatePasswordFormGroup: UntypedFormGroup;
  public confirmacaoFormGroup: UntypedFormGroup;
  public tipoPessoa: string = 'F';
  public bancos: any[] = [];
  public bancoSelecionado: any = null;
  public tiposDocumento = [{
    valor: 'rg',
    descricao: 'RG'
  }, {
    valor: 'cng',
    descricao: 'CNH'
  }, {
    valor: 'rne',
    descricao: 'RNE'
  }]
  public generos = [{
    valor: 'feminino',
    descricao: 'genero_feminino'
  }, {
    valor: 'masculino',
    descricao: 'genero_masculino'
  }, {
    valor: 'outro',
    descricao: 'genero_outro'
  }, {
    valor: 'prefiro_nao_dizer',
    descricao: 'genero_prefiro_nao_dizer'
  }]
  public loading = false;
  public loadingUpdate = false;
  public confirmacao: ConfirmationResult;
  danger: boolean = false;
  fileUpload: File | any = null;
  fileToSave: File | any = null;
  imageUser: string = null;

  constructor(
    private firebaseAuth: AngularFireAuth,
    public firebase: FirebaseService,
    private functions: FunctionsService,
    private formBuilder: UntypedFormBuilder,
    private utilitarios: UtilitariosDataService,
    private staticData: StaticDataService,
  ) { }

  ngOnInit(): void {
    const profile = this.firebase.profile || {};
    this.imageUser = profile.photoUrl;
    this.clienteFormGroup = this.formBuilder.group({
      cpf_cnpj: [{ value: profile.cpf_cnpj, disabled: false }, [
        Validators.required,
        PessoaValidador.cpfOrCnpj
      ]],
      nome: [{ value: profile.nome, disabled: false }, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(60)
      ]],
      nome_contato: [{ value: profile.nome_contato, disabled: false }, [
        Validators.minLength(5),
        Validators.maxLength(60)
      ]],
      email: [{ value: profile.email, disabled: false }, [
        Validators.required,
        Validators.email
      ]],
      telefone: [{ value: profile.telefone, disabled: false }, [
        Validators.required
      ]],
      documento: [{ value: profile.documento, disabled: false }, [
        Validators.minLength(3)
      ]],
      tipo_documento: [{ value: profile.tipo_documento, disabled: false }, [
        Validators.required
      ]],
      genero: [{ value: profile.genero, disabled: false }, [
        Validators.required
      ]],
      telegram: [{ value: profile.telegram, disabled: false }, []],
      inscricao_municipal: [{ value: profile.inscricao_municipal, disabled: false }, []],
      inscricao_estadual: [{ value: profile.inscricao_estadual, disabled: false }, []]
    });

    const endereco_principal = profile.endereco_principal || {};
    this.enderecoFormGroup = this.formBuilder.group({
      cep: [{ value: endereco_principal.cep, disabled: false }, [
        Validators.required
      ]],
      logradouro: [{ value: endereco_principal.logradouro, disabled: false }, [
        Validators.required
      ]],
      numero: [{ value: endereco_principal.numero, disabled: false }, [
        Validators.required
      ]],
      complemento: [{ value: endereco_principal.complemento, disabled: false }, [

      ]],
      bairro: [{ value: endereco_principal.bairro, disabled: false }, [
        Validators.required
      ]],
      cidade: [{ value: endereco_principal.cidade, disabled: false }, [
        Validators.required
      ]],
      estado: [{ value: endereco_principal.estado, disabled: false }, [
        Validators.required
      ]],
      pais: [{ value: endereco_principal.pais, disabled: true }, [
        Validators.required,
      ]]
    })

    const dados_bancarios = profile.dados_bancarios || {};
    this.dadosBancariosFormGroup = this.formBuilder.group({
      banco_codigo: [{ value: dados_bancarios.banco_codigo, disabled: false }, []],
      banco_nome: [{ value: dados_bancarios.banco_nome, disabled: false }, []],
      agencia: [{ value: dados_bancarios.agencia, disabled: false }, []],
      conta: [{ value: dados_bancarios.conta, disabled: false }, []],
      chave_pix: [{ value: dados_bancarios.chave_pix, disabled: false }, []],
    });

    this.staticData.bancos().toPromise()
      .then(response => {
        this.bancos = response.body;
        if (dados_bancarios.banco_codigo) {
          this.bancoSelecionado = this.bancos.find(
            banco => banco.codigo === dados_bancarios.banco_codigo
          ) || null;
        }
      })
      .catch(error => {
        console.error(error);
      });

    this.updatePasswordFormGroup = this.formBuilder.group({
      nova_senha: [{ value: '', disabled: false }, [
        Validators.minLength(8),
        Validators.maxLength(15)
      ]],
      confirmacao_nova_senha: [{ value: '', disabled: false }, []],
      senha_antiga: [{ value: '', disabled: false }, []]

    });

    this.confirmacaoFormGroup = this.formBuilder.group({
      codigo: [{ value: '', disabled: false }, [
        Validators.required
      ]]
    });

    this.clienteFormGroup.controls['cpf_cnpj'].valueChanges.subscribe(observer => {
      if (observer.length <= 11) this.tipoPessoa = 'F';
      else this.tipoPessoa = 'J';

      if (this.tipoPessoa === 'J') {
        this.clienteFormGroup.controls['documento'].removeValidators(Validators.required)
        this.clienteFormGroup.controls['tipo_documento'].removeValidators(Validators.required)
        this.clienteFormGroup.controls['genero'].removeValidators(Validators.required);
        this.clienteFormGroup.controls['genero'].setValue('');
        this.clienteFormGroup.controls['nome_contato'].addValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_municipal'].addValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_estadual'].addValidators(Validators.required);
      } else {
        this.clienteFormGroup.controls['documento'].addValidators(Validators.required)
        this.clienteFormGroup.controls['tipo_documento'].addValidators(Validators.required)
        this.clienteFormGroup.controls['genero'].addValidators(Validators.required);
        this.clienteFormGroup.controls['nome_contato'].removeValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_municipal'].removeValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_estadual'].removeValidators(Validators.required);
      }

      this.clienteFormGroup.controls['documento'].updateValueAndValidity();
      this.clienteFormGroup.controls['tipo_documento'].updateValueAndValidity();
      this.clienteFormGroup.controls['genero'].updateValueAndValidity();
      this.clienteFormGroup.controls['nome_contato'].updateValueAndValidity();
      this.clienteFormGroup.controls['inscricao_municipal'].updateValueAndValidity();
      this.clienteFormGroup.controls['inscricao_estadual'].updateValueAndValidity();
      this.clienteFormGroup.updateValueAndValidity();

    });

    // @ts-ignore
    window.clienteFormGroup = this.clienteFormGroup
  }

  onUpload(event: UploadEvent) {
    // for (let file of event.files) {
    // this.uploadedFiles.push(file);
    // }
    console.log(event.files)
    // this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
  }

  onSelect(event) {
    this.fileToSave = event.currentFiles[0];
    this.functions.uploadPhotoClient(this.fileToSave).pipe().subscribe({
      next: (res) => {
        this.fileUpload = event.currentFiles[0].objectURL.changingThisBreaksApplicationSecurity;
        this.firebase.profile.photoUrl = this.fileUpload;
        console.log(res)
      },
      error: (error) => {
        console.error(error)
      },
      complete: () => {
      }
    })
    console.log(event.currentFiles)
  }

  removePhoto() {
    this.functions.removePhotoClient().pipe().subscribe({
      next: (res) => {
        console.log(res)
        this.fileUpload = null;
        this.fileToSave = null;
        this.imageUser = null;
        this.firebase.profile.photoUrl = null;
      },
      error: (error) => {
        console.error(error)
      },
      complete: () => {
      }
    })
  }
  aoSelecionarBanco() {
    this.dadosBancariosFormGroup.controls['banco_codigo'].setValue(this.bancoSelecionado?.codigo ?? null);
    this.dadosBancariosFormGroup.controls['banco_nome'].setValue(this.bancoSelecionado?.nome ?? null);
  }

  buscaCep() {
    if (this.enderecoFormGroup.controls['cep'].invalid) {
      alert('Por favor, informe um CEP válido');
      return;
    }

    this.utilitarios.cep(this.enderecoFormGroup.controls['cep'].value, null).toPromise()
      .then(res => {
        console.info(res.body);
        this.convertViaCEPParaFormulario(res.body);
      })
      .catch(error => {
        console.error(error)
        alert('Não encontramos o CEP informado');
        this.convertViaCEPParaFormulario(null);
      })
  }

  convertViaCEPParaFormulario(endereco: any) {
    if (!endereco) {
      Object.keys(this.enderecoFormGroup.controls).forEach(key => {
        this.enderecoFormGroup.controls[key].setValue(null);
      });

      return;
    }

    const { logradouro, bairro, cidade, estado } = this.enderecoFormGroup.controls;

    logradouro.setValue(endereco.logradouro);
    bairro.setValue(endereco.bairro)
    cidade.setValue(endereco.localidade)
    estado.setValue(endereco.uf)
  }

  proximo() {
    if (this.clienteFormGroup.invalid) {
      alert('Por favor, preencha corretamente todos os campos em destaque.');
      return;
    }
  }

  registro() {
    this.clienteFormGroup.markAllAsTouched();
    this.enderecoFormGroup.markAllAsTouched();

    if (this.clienteFormGroup.invalid || this.enderecoFormGroup.invalid) {
      alert('Por favor revise os campos destacados em vermelho');
      !this.clienteFormGroup.controls['tipo_documento']?.value ? this.danger = true : this.danger = true;
      return;
    }
    this.danger = false;

    this.loading = true;

    this.clienteFormGroup.disable();
    this.enderecoFormGroup.disable();
    this.dadosBancariosFormGroup.disable();

    const payload: any = {
      uid: this.firebase.user.uid,
      endereco_principal: {},
      dados_bancarios: {}
    };

    Object.keys(this.clienteFormGroup.controls).forEach(key => {
      const valor = this.clienteFormGroup.controls[key].value;
      if (!valor) return;
      payload[key] = valor;
    });
    Object.keys(this.enderecoFormGroup.controls).forEach(key => {
      payload.endereco_principal[key] = this.enderecoFormGroup.controls[key].value;
    });
    Object.keys(this.dadosBancariosFormGroup.controls).forEach(key => {
      payload.dados_bancarios[key] = this.dadosBancariosFormGroup.controls[key].value;
    });

    this.functions.atualizarCliente(payload, null).toPromise()
      .then(res => {
        // this.firebase.entrarComTelefone(
        //   `+55${this.clienteFormGroup.controls['telefone'].value}`
        // )
        //   .then(res => {
        //     this.confirmacao = res;
        //     // this.editarDadosClienteStepper.next();
        //   })
        //   .catch(error => {
        //     alert('Ops, houve um erro ao enviar o código de acesso. Por favor, tente novamente.')
        //     console.error(error)
        //   })
        //   .finally(() => {
        //     this.loading = false;
        //     this.clienteFormGroup.enable();
        //     this.enderecoFormGroup.enable();
        //   })

        this.loading = false;
        this.clienteFormGroup.enable();
        this.enderecoFormGroup.enable();
        this.dadosBancariosFormGroup.enable();

        location.reload();
      })
      .catch(error => {
        console.error(error);
        if (error.status === 406) {
          alert('E-mail ou telefone já cadastrado.');
        } else {
          alert('Ops, não conseguimos finalizar o seu cadastro. Por favor, tente mais tarde.');
        }
        this.loading = false;
        this.clienteFormGroup.enable();
        this.enderecoFormGroup.enable();
        this.dadosBancariosFormGroup.enable();
      })
  }

  async updatePassword() {
    if (this.updatePasswordFormGroup.controls['nova_senha'].value != '') {
      this.updatePasswordFormGroup.addValidators(
        SegurancaValidador.confirmacaoNovaSenha('nova_senha', 'confirmacao_nova_senha')
      )
    }

    this.updatePasswordFormGroup.markAllAsTouched();

    if (this.updatePasswordFormGroup.invalid) {
      alert('Por favor revise os campos destacados em vermelho');
      return;
    }

    this.updatePasswordFormGroup.disable();

    this.loadingUpdate = true;

    const payload: any = {
      uid: this.firebase.user.uid,
    };

    Object.keys(this.updatePasswordFormGroup.controls).forEach(key => {
      const valor = this.updatePasswordFormGroup.controls[key].value;
      if (!valor) return;
      payload[key] = valor;
    });
    const user = this.firebaseAuth.currentUser;
    payload['email'] = this.firebase.user.email
    const credential = firebase?.auth?.EmailAuthProvider?.credential?.(payload.email, payload.senha_antiga);
    (await user).reauthenticateWithCredential(credential)
      .then(async () => {
        // Após a reautenticação bem-sucedida, atualiza a senha
        return (await user).updatePassword(payload.nova_senha);
      })
      .then(() => {
        alert('Senha atualizada com sucesso!');
        // Faça o que precisar após a atualização da senha
      })
      .catch((error) => {
        alert('Erro ao atualizar a senha: ' + error);
      }).finally(() => {
        this.loadingUpdate = false
        this.updatePasswordFormGroup.enable();
        location.reload();
      });
  }

  verificarCodigoSMS() {
    if (this.confirmacaoFormGroup.invalid) {
      alert('Por favor, informe o código de verificação');
      return;
    }

    this.loading = true;
    this.confirmacaoFormGroup.disable();
    this.confirmacao.confirm(this.confirmacaoFormGroup.controls['codigo'].value)
      .then(res => {
        // ok
      })
      .catch(error => {
        alert('Ops, não pudemos validar o código. Por favor, tente de novo.')
        console.error(error)
      })
      .finally(() => {
        this.confirmacaoFormGroup.enable();
        this.loading = false;
      })
  }
}
